mod.modules.define("Template", function(fn) {
	"use strict";

	// Save off some DOM nodes
	var cache = {
		$modules: null,
		$empty: null
	};

	// Define some properties used by the Sortable plugin
	var sortable = {
		margin: 20,
		baseWidth: 300,
		baseHeight: 400,
		maxColWidth: 3
	};

	fn.prototype.init = function() {
		cache.$modules = this.el.find("#modules");
		cache.$empty = $("<li class='invisible'><div class='size1 widget module' data-size='1' /></li>");
		cache.$placeholder = $("<li />");

		// Setup sorting
		this.attachSortable();

		// Publish a an event when the widgets resize
		this.triggerReposition();
	};

	fn.prototype.attachSortable = function() {
		cache.$modules.sortable({
			forcePlaceholderSize: true,
			forceHelperSize: true,
			revert: 100,
			handle: ".module-header",
			tolerance: "pointer",
			cursor: "move",
			stop: $.proxy(this.triggerReposition, this)
		});
	};

	fn.prototype.fillEmptySpace = function() {
		// Remove all existing placeholders
		cache.$modules.find("li.invisible").remove();
		var $items = cache.$modules.children();

		// Track some vars as we go
		var currentRowNum = 0;
		var currentRowWidth = 0;
		var currentIndex = 0;

		for (var i = 0; i < $items.length; i++) {
			var $item = $items.eq(i);
			var $module = $item.children().first();
			var itemSize = parseInt($module.attr("data-size"), 10);

			// See if we'll fit in this row
			if (currentRowWidth + itemSize > sortable.maxColWidth) {
				// See if there's empty space we need to fill
				if (sortable.maxColWidth - currentRowWidth) {
					var $newEmpty = cache.$empty.clone().css({
						left: (sortable.margin * currentRowWidth) + (currentRowWidth * sortable.baseWidth),
						top: (sortable.margin * currentRowNum) + (currentRowNum * sortable.baseHeight)
					});

					$item.before($newEmpty);
				}

				// Start a new "row"
				currentRowNum += 1;
				currentRowWidth = 0;
				currentIndex = 0;
			}

			// Increment where we are on the current "row"
			currentRowWidth += itemSize;
			currentIndex += 1;
		}
	};

	fn.prototype.receiveNewModule = function(module) {
		var self = this;

		// Create a new list item for the module to load into
		var $placeholder = $("<li />");

		// Load the new widget
		mod.modules.widgetapi.load({
			widgets: {
				appId: module.id,
				context: module.context
			},
			success: function(response, inlineFn) {
				// Add the placeholder to the list on success
				self.el.find("#modules").append($placeholder);
				inlineFn();

				self.triggerReposition();
				self.triggerScrollTo("widget-com_" + module.type);
			},
			container: $placeholder,
			disableInlines: true
		});
	};

	fn.prototype.receiveTemplateId = function(templateId) {
		this.reloadQueue({
			UserTemplateId: templateId
		});
	};

	fn.prototype.triggerReposition = function() {
		// Run through the list of modules and put "empty" containers in all the gaps
		// e.g., Add to the right of a row with a single size2 module
		this.fillEmptySpace();

		mod.observer.trigger("modules - repositioned", this._getWidgets());
	};

	fn.prototype.triggerScrollTo = function (module_id) {
		mod.observer.trigger("modules - scrollTo", module_id);
	};

	fn.prototype._getWidgets = function() {
		var positions = [];
		var $modules = cache.$modules.find("div.widget");

		for (var i = 0, len = $modules.length; i < len; i++) {
			var module = $modules[i];
			var $module = $modules.eq(i);

			// Skip over our "invisible" placeholders
			if (module.id) {
				var widgetSize = module.getAttribute("data-size");
				var widgetType = module.getAttribute("data-type");
				var widgetTypeStr = module.getAttribute("data-typestr");
				var widgetTitle = module.getAttribute("data-title");
				var top = $module.position().top;
				var bottom = top + $module.height();

				positions.push({
					id: module.id,
					type: widgetType,
					typestr: widgetTypeStr,
					size: widgetSize,
					title: widgetTitle,
					el: module,
					top: top,
					bottom: bottom
				});
			}
		}

		return positions;
	};

	fn.prototype.observables = {
		"modules - position requested": function() {
			this.triggerReposition();
		},
		"module - removed": function(module) {
			module.el.closest("li").remove();

			this.triggerReposition();
		},
		"module - resized": function() {
			this.triggerReposition();
		},
		"template changed": function(params) {
			this.receiveTemplateId(params);
		},
		"new module requested": function(params) {
			this.receiveNewModule(params);
		}
	};

});